var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelaxed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:12;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -53.0194 128)",
    className: "st0",
    cx: 128,
    cy: 128,
    rx: 117.5,
    ry: 117.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.2,147.7c-8.4,26.9-33.5,46.5-63.2,46.5s-54.8-19.6-63.2-46.5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 69.8,
    y1: 144.8,
    x2: 57.8,
    y2: 150.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 186.2,
    y1: 144.8,
    x2: 198.2,
    y2: 150.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.3,99.7c2.5,4.4,7.2,7.3,12.6,7.3c5,0,9.5-2.6,12.1-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M193.7,99.7c-2.5,4.4-7.2,7.3-12.6,7.3c-5,0-9.5-2.6-12.1-6.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelaxed);
export default __webpack_public_path__ + "static/media/Relaxed.0f8a350c05c57c0d5768421647dd4484.svg";
export { ForwardRef as ReactComponent };